export default __webpack_public_path__ + "static/media/positiveMindset.da0f0e15.png";